import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');
const Button = videojs.getComponent('MenuButton');

class CustomBarPlugin extends Plugin {
  constructor(player, options) {
    super(player);

    const self = this;
    self.playerId = this.player.id();
    // TODO
    this.player.el().classList.add('video-js--loading');

    this.options = {...options};
    this.player.ready(() => {
      if (this.options.buildCustomBar) {
        this.player.addClass('scaleup-custom-bar');
        this.buildCustomBarUI();
      }
    });
  }

  buildCustomBarUI() {
    const self = this;

    //Wrapper da control bar + play e pause
    const customBarDiv = videojs.dom.createEl('div');
    customBarDiv.className = 'scaleup-custom-bar scaleup-custom-bar--wrapper';
    customBarDiv.id = self.playerId + '-scaleup-custom-bar';

    this.changeIcons();
    const playToggle = self.player.getChild('controlBar').getChild('playToggle').el();
    const summaryToggle = self.player.getChild('controlBar').getChild('summaryButton') ? self.player.getChild('controlBar').getChild('summaryButton').el() : null;
    const controlBar = self.player.getChild('controlBar');
    controlBar.getChild('subsCapsButton').controlText('Legenda');
    controlBar
      .el()
      .insertBefore(controlBar.getChild('subsCapsButton').el(), controlBar.getChild('settingsMenuButton').el());

    customBarDiv.appendChild(playToggle);

    if (summaryToggle) {
      customBarDiv.appendChild(summaryToggle);
    }

    customBarDiv.appendChild(controlBar.el());

    document.getElementById(self.playerId).appendChild(customBarDiv);

    // TODO
    setTimeout(() => {
      self.player.el().classList.remove('video-js--loading');
    }, 100);
  }

  changeIcons() {
    const playToggle = this.player.getChild('controlBar').getChild('playToggle').el();
    playToggle.classList.add('vjs-paused');
    const pauseButtonIcon = document.createElement('i');
    pauseButtonIcon.className = 'fa-solid fa-pause';
    const playButtonIcon = document.createElement('i');
    playButtonIcon.className = 'fa-solid fa-play';
    const replayButtonIcon = document.createElement('i');
    replayButtonIcon.className = 'fa-solid fa-arrow-rotate-left';
    playToggle.appendChild(playButtonIcon);
    playToggle.appendChild(pauseButtonIcon);
    playToggle.appendChild(replayButtonIcon);

    const fullscreenToggle = this.player.getChild('controlBar').getChild('fullscreenToggle').el();
    const fullscreenIcon = document.createElement('i');
    fullscreenIcon.className = 'fa-solid fa-expand-wide';
    const compressIcon = document.createElement('i');
    compressIcon.className = 'fa-solid fa-down-left-and-up-right-to-center';
    fullscreenToggle.appendChild(fullscreenIcon);
    fullscreenToggle.appendChild(compressIcon);

    const subsCapsButton = this.player.getChild('controlBar').getChild('subsCapsButton').el();
    const subsCapsIcon = document.createElement('i');
    subsCapsIcon.innerHTML = `
    <svg class="fa-leg-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
      <rect y="0.279785" width="16" height="12.44" rx="2" fill="currentColor"/>
      <path d="M2.64526 8.6816V4.31796H3.56785V7.92094H5.43859V8.6816H2.64526Z" fill="black"/>
      <path d="M5.92956 8.6816V4.31796H8.8699V5.07861H6.85215V6.11839H8.71862V6.87904H6.85215V7.92094H8.87842V8.6816H5.92956Z" fill="black"/>
      <path d="M12.3769 5.72847C12.347 5.62478 12.3051 5.53316 12.2511 5.45361C12.1972 5.37265 12.1311 5.30447 12.053 5.24907C11.9763 5.19225 11.8882 5.14893 11.7888 5.1191C11.6908 5.08927 11.5821 5.07435 11.4628 5.07435C11.2398 5.07435 11.0438 5.12975 10.8747 5.24055C10.7071 5.35134 10.5764 5.51256 10.4827 5.72421C10.3889 5.93444 10.3421 6.19154 10.3421 6.49552C10.3421 6.79949 10.3882 7.05802 10.4805 7.27108C10.5729 7.48415 10.7036 7.6468 10.8726 7.75901C11.0416 7.86981 11.2412 7.9252 11.4713 7.9252C11.6801 7.9252 11.8584 7.88827 12.0061 7.81441C12.1553 7.73912 12.2689 7.6333 12.347 7.49694C12.4266 7.36057 12.4663 7.19935 12.4663 7.01327L12.6538 7.04097H11.5288V6.34637H13.3548V6.89608C13.3548 7.27961 13.2739 7.60915 13.1119 7.88472C12.95 8.15887 12.727 8.37052 12.4429 8.51966C12.1588 8.66739 11.8335 8.74126 11.4671 8.74126C11.058 8.74126 10.6986 8.65106 10.3889 8.47066C10.0793 8.28884 9.83779 8.03103 9.6645 7.69722C9.49262 7.36199 9.40668 6.96427 9.40668 6.50404C9.40668 6.15035 9.45782 5.83501 9.56009 5.55802C9.66379 5.27961 9.80867 5.04381 9.99475 4.85063C10.1808 4.65745 10.3975 4.51043 10.6446 4.40958C10.8918 4.30873 11.1595 4.2583 11.4479 4.2583C11.695 4.2583 11.9252 4.29452 12.1382 4.36697C12.3513 4.43799 12.5402 4.53884 12.705 4.66952C12.8712 4.8002 13.0068 4.95574 13.1119 5.13614C13.2171 5.31512 13.2845 5.51256 13.3144 5.72847H12.3769Z" fill="black"/>
    </svg>
    `;
    subsCapsButton.appendChild(subsCapsIcon);

    const volumePanel = this.player.getChild('controlBar').getChild('volumePanel').getChild('muteToggle').el();
    const mutedIcon = document.createElement('i');
    mutedIcon.className = 'fa-solid fa-volume-xmark';
    const volumeLow = document.createElement('i');
    volumeLow.className = 'fa-solid fa-volume-low';
    const volumeMedium = document.createElement('i');
    volumeMedium.className = 'fa-solid fa-volume';
    const volumeHigh = document.createElement('i');
    volumeHigh.className = 'fa-solid fa-volume-high';
    volumePanel.appendChild(mutedIcon);
    volumePanel.appendChild(volumeLow);
    volumePanel.appendChild(volumeMedium);
    volumePanel.appendChild(volumeHigh);
  }
}

CustomBarPlugin.defaultState = {};

videojs.registerPlugin('customBarPlugin', CustomBarPlugin);

export default CustomBarPlugin;
